"use strict";
var IS_PURE = require("../internals/is-pure");
var globalThis = require("../internals/global-this");
var fails = require("../internals/fails");
var WEBKIT = require("../internals/environment-webkit-version");
module.exports = IS_PURE || !fails(function() {
  if (WEBKIT && WEBKIT < 535) return;
  var key = Math.random();
  __defineSetter__.call(null, key, function() {
  });
  delete globalThis[key];
});
